"use client";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Wrapper } from "../ui/wrapper";
import { BookOpen, ChevronDown, Plus } from "lucide-react";
import { useUserStore, useFormStore } from "@/core/stores";
import { Button } from "../ui/button";
import { SidebarFormItem } from "@/components/form/form-item";
import { useRouter } from "next/navigation";
import { useSignOut } from "@/hooks/provider/use-sign-out";
import { useCreateForm } from "@/hooks/provider/use-create-form";

export function Sidebar() {
  const { user } = useUserStore();
  const { forms } = useFormStore();
  const { resetAll } = useCreateForm();
  const router = useRouter();
  const toCreateForm = () => {
    resetAll();
    router.push("/form/create");
  };
  const { signOut } = useSignOut();

  return (
    <aside className="border-r border-gray-200 h-full flex flex-col gap-3 !w-[280px]">
      <div className="px-4 py-3 flex items-center gap-3 border-b border-gray-200">
        <div className="flex-1 flex items-center gap-2">
          <div className="rounded border border-blue-100 bg-blue-50 w-6 h-6 grid place-items-center text-blue-500 text-13sb">
            {user.email?.[0].toLocaleUpperCase()}
          </div>
          <div className="text-gray-500 text-13m">{user.email}</div>
        </div>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button>
              <Wrapper.Icon>
                <ChevronDown />
              </Wrapper.Icon>
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            <DropdownMenuItem onClick={signOut}>로그아웃</DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
      <div className="px-1 flex flex-col gap-[6px] flex-grow">
        <div className="px-3 flex items-center justify-between">
          <div className="text-gray-400 text-14m">내 폼 {forms.length}개</div>
          <Button
            size="sm"
            variant="secondary"
            className="flex items-center gap-0.5"
            onClick={toCreateForm}
          >
            <Plus size={18} className="text-gray-600" />
            <div>새 폼</div>
          </Button>
        </div>
        <div className="flex-grow relative">
          <div className="absolute inset-0 flex flex-col gap-1.5 overflow-y-auto">
            {forms.map((form, i) => (
              <SidebarFormItem key={i} {...form} />
            ))}
          </div>
        </div>
        <div className="py-3 px-1 border-t border-gray-200">
          <a
            href="/manual"
            target="_blank"
            rel="noopener noreferrer"
            className="py-[5px] px-3 flex items-center gap-2.5 hover:bg-gray-100 rounded-lg duration-200 cursor-pointer"
          >
            <span className="cursor-pointer text-gray-600 text-15m">
              사용자 가이드
            </span>
            <BookOpen size={20} className="text-gray-400" />
          </a>
        </div>
      </div>
    </aside>
  );
}
